<template>
  <div class="image-text">
    <slot name="text"></slot>
    <slot name="image"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextTopRight",
};
</script>

<style lang="scss" scoped>
.image-text {
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}
</style>
